<template>
	<div class="left_option">
		<em class="lt_text">User Defined Group</em>
		<span class="int_type half_int"> <autocomplete ref="ac" :source="list" @selected="selectClass" results-display="name" placeholder="User Defined Group Name" :disableInput="all" /> </span>
		<span class="int_type_no_border mgr_5">
			<input type="text" class="tbl_int" v-model.trim="name_string" autocomplete="off" style="width:300px;" @input="changeValue" :disabled="all" />
		</span>
		<span v-if="displayAll">
			<input type="checkbox" v-model="all" @change="changeAll" />
			<em>ALL</em>
		</span>
	</div>
</template>
<script>
import { apiSelectUserDefinedGroups } from '@/api/item/userDefined';

export default {
	name: 'SelectUserDefinedGroup',
	data: function() {
		return {
			name_string: null,
			list: [],
			all: false,
		};
	},
	props: {
		displayAll: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		itemClasses: function() {
			let string = this.name_string;
			if (string) {
				return string.trim().split('|');
			} else {
				return [];
			}
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		async apiSelectData() {
			const { data } = await apiSelectUserDefinedGroups('');
			this.list = data;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.name_string) this.name_string += '|' + c.selectedObject.name;
			else this.name_string = c.selectedObject.name;
			this.update();
		},
		changeValue() {
			this.update();
		},
		reset() {
			this.name_string = null;
			this.update();
		},
		update() {
			this.$emit('input', this.name_string);
		},
		changeAll() {
			this.name_string = null;
			this.$emit('change', this.all);
			this.update();
		},
		isContain(name) {
			return this.list.some(el => el.name === name);
		},
		getUdNo(name) {
			let res = null;
			if (name) {
				let idx = this.list.findIndex(el => el.name === name);
				if (idx > -1) res = this.list[idx].udNo;
			}

			return res;
		},
	},
	mounted() {
		this.apiSelectData();
	},
};
</script>
